import type { UseCase } from 'cf-types'

export interface PaymentsCompleteScreenDialogContentProps {
  redirectToConfirmation?: boolean
  useCase?: UseCase
  reloadOnModalClose?: boolean
}

export const PAYMENTS_COMPLETE_SCREEN_DIALOG_CLOSED_EVENT_NAME =
  'payments-complete-screen-dialog-closed'
export const STUDIO_AI_EXCLUSIVE_OFFER_MODAL_START_COUNTER_EVENT_NAME =
  'studio-ai-exclusive-offer-modal-start-counter'
